import React from 'react'

import {
  Container,
  Row,
  Col
} from 'reactstrap'

export default class CustomFooter extends React.Component {
  render () {
    return (
      <Container fluid style={{ backgroundColor: '#2e303c', color: '#7d9eb0', minHeight: '7em' }}>
        <Container style={{ minHeight: '7em' }}>
          <Row style={{ minHeight: '7em' }}className='d-flex align-content-center'>
            <Col className='d-flex align-content-center flex-wrap' md='5'>
              <p className='mb-0'>&copy; 2016 &ndash; {new Date().getFullYear()} Vanderbilt University Medical Center</p>
            </Col>
            <Col md='7' className='d-flex justify-content-end align-content-center flex-wrap'>
              <p className='mb-0'>Site development and hosting by Creative Data Solutions</p>
            </Col>
          </Row>
        </Container>
      </Container>
    )
  }
}
